<template>
  <v-dialog
    v-model="active"
    width="480"
    persistent
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        color="secondary"
        large
        v-bind="attrs"
        v-on="on"
      >
        Registrar expediente
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Registro de expediente
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-center"
          >
            <div class="text-subtitle-1 font-weight-bold mb-2">
              Llenar campos con información de personal
            </div>
            <v-text-field
              v-model="search"
              label="No. personal SSC"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              hide-details=""
            />
            <v-btn
              color="secondary"
              rounded
              class="px-8 ma-2"
              :disabled="loading"
              :loading="loading"
              @click="triggerSearchPersonal()"
            >
              Buscar
            </v-btn>
          </v-col>
        </v-row>
        <v-form
          ref="form"
          v-model="nuevoExpedienteForm"
        >
          <div class="text-subtitle-2 mb-2 text--secondary">
            Información de expediente
          </div>
          <v-text-field
            v-model="expediente.folio"
            label="Folio de expediente"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            hide-details
          />
          <v-divider
            class="my-4"
            color="secondary"
          />
          <div class="text-subtitle-2 mb-2 text--secondary">
            Información del elemento
          </div>
          <v-text-field
            v-model="personal.curp"
            label="CURP"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="validCurp"
            maxlength="18"
            counter
          />
          <v-text-field
            v-model="personal.nombre"
            label="Nombre *"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
          />
          <v-text-field
            v-model="personal.segundoNombre"
            label="Segundo nombre"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          />
          <v-text-field
            v-model="personal.apaterno"
            label="Apellido paterno"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          />
          <v-text-field
            v-model="personal.amaterno"
            label="Apellido materno"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          />
          <v-text-field
            v-model.number="expediente.antiguedadInstitucion"
            label="Antigüedad en la institución"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            type="number"
            min="0"
          />
          <v-text-field
            v-model="personal.unidadAnalisisTactico"
            label="Dependencia"
            rounded
            filled
            dense
            background-color="primary"
            color="secondary"
          />
          <v-text-field
            v-model="personal.unidadInvestigacion"
            label="Área de adscripción"
            rounded
            filled
            dense
            background-color="primary"
            color="secondary"
          />
          <v-text-field
            v-model="personal.unidadOperaciones"
            label="Puesto"
            rounded
            filled
            dense
            background-color="primary"
            color="secondary"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          class="px-8"
          :disabled="loading || !nuevoExpedienteForm"
          :loading="loading"
          @click="triggerSaveExpediente()"
        >
          Registrar expediente
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      active: false,
      loading: false,
      nuevoExpedienteForm: false,
      search: '',

      personal: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        fechaNacimiento: '',
        nacionalidad: '',
        curp: '',
        nss: '',
        nsmi: '',
        pasaporte: '',
        rfc: '',
        claveIne: '',
        licenciaConducir: '',
        vigenciaLicencia: 0,
        foto: '',
        fk_idTipoNacionalidad: 0,
        fk_idEstadoCivil: 0,
        fk_idEstatus: 6,
        fk_idMunicipioNacimiento: 0,
        fk_idMunicipioRadica: 0,
        fk_idPuestoDependencia: 0,
        fk_idRamaDependencia: 0,
        fk_idSubsede: 0,
        Contacto: {
          telefonoCelular: '',
          telefonoFijo: '',
          correoElectronico: 'correo@dominio.com',
          Direccion: {
            fk_idMunicipio: 0,
            calle: '',
            colonia: '',
            ext: '',
            int: '',
            entrecalles: '',
            entrecalles2: '',
            referencias: '',
            lat: '',
            lgt: '',
            cp: '',
          },
        },
        cartillaMilitar: '',
        fk_idCatGrupoSanguineo: 0,
        aptoSNPSP: true,
        fk_idCatArea: 0,
        capturo: '',
        fechaCaptura: '',
        ncp: '',
        smn: '',
        escolaridad: '',
        rangoCategoria: '',
        funciones: '',
        categorizacion: '',
        sueldoBase: '',
        jerarquiaPuesto: '',
        criticidadPuestoOperativo: '',
        categoriaPuestoCnca: '',
        funcional: '',
        unidadInvestigacion: '',
        unidadOperaciones: '',
        unidadAnalisisTactico: '',
        fechaIngresoEdoFza: '',
        estatusSnsp: '',
        estarLn: '',
        fechaBaja: '',
        motivoBaja: '',
        observaciones: '',
        examenC3Mes: '',
        vigenciaAnio: 0,
        observacionesC3: '',
        fk_idCatAmbito: 0,
      },

      expediente: {
        folio: '',
        antiguedadInstitucion: 0,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
      validCurp: [
        (v) => !!v || 'Este campo es requerido',
        (v) => !this.validaCurp(v) || 'La CURP ingresada ya se encuentra registrada.',
      ],
      personalEdoFuerza: null,
    };
  },

  computed: {
    ...mapGetters('personal', {
      savedIdPersonal: 'getSavedIdPersonal',
    }),

    ...mapGetters('expediente', {
      expedienteId: 'getSavedExpedienteId',
      expedientePersonal: 'getExpedientesPersonal',
      expedientes: 'getExpedientes',
    }),
  },

  methods: {
    ...mapActions('personal', [
      'savePersonal',
      'updatePersonal',
      'saveCuip',
      'searchPersonal',
      'updatePersonalEdoFuerza',
    ]),
    ...mapActions('expediente', ['saveExpediente', 'fetchExpedientes', 'updateFolioExpediente']),

    closeDialog() {
      this.personal = {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        fechaNacimiento: '',
        nacionalidad: '',
        curp: '',
        nss: '',
        nsmi: '',
        pasaporte: '',
        rfc: '',
        claveIne: '',
        licenciaConducir: '',
        vigenciaLicencia: 0,
        foto: '',
        fk_idTipoNacionalidad: 0,
        fk_idEstadoCivil: 0,
        fk_idEstatus: 6,
        fk_idMunicipioNacimiento: 0,
        fk_idMunicipioRadica: 0,
        fk_idPuestoDependencia: 0,
        fk_idRamaDependencia: 0,
        fk_idSubsede: 0,
        Contacto: {
          telefonoCelular: '',
          telefonoFijo: '',
          correoElectronico: 'correo@dominio.com',
          Direccion: {
            fk_idMunicipio: 0,
            calle: '',
            colonia: '',
            ext: '',
            int: '',
            entrecalles: '',
            entrecalles2: '',
            referencias: '',
            lat: '',
            lgt: '',
            cp: '',
          },
        },
        cartillaMilitar: '',
        fk_idCatGrupoSanguineo: 0,
        aptoSNPSP: true,
        fk_idCatArea: 0,
        capturo: '',
        fechaCaptura: '',
        ncp: '',
        smn: '',
        escolaridad: '',
        rangoCategoria: '',
        funciones: '',
        categorizacion: '',
        sueldoBase: '',
        jerarquiaPuesto: '',
        criticidadPuestoOperativo: '',
        categoriaPuestoCnca: '',
        funcional: '',
        unidadInvestigacion: '',
        unidadOperaciones: '',
        unidadAnalisisTactico: '',
        fechaIngresoEdoFza: '',
        estatusSnsp: '',
        estarLn: '',
        fechaBaja: '',
        motivoBaja: '',
        observaciones: '',
        examenC3Mes: '',
        vigenciaAnio: 0,
        observacionesC3: '',
        fk_idCatAmbito: 0,
      };

      this.expediente = {
        folio: '',
        antiguedadInstitucion: 0,
      };

      this.$refs.form.resetValidation();

      this.active = false;
      this.loading = false;
    },

    async triggerSaveExpediente() {
      this.loading = true;

      this.personal.antiguedadInstitucion = this.expediente.antiguedadInstitucion;

      await this.savePersonal({
        ...this.personal,
        fk_idCatArea: null,
        fk_idCatSubArea: null,
      });
      await this.saveExpediente({
        fk_idPersonal: this.savedIdPersonal,
        antiguedadInstitucion: this.expediente.antiguedadInstitucion,
      });

      if (this.expediente.folio.length > 0) {
        await this.updateFolioExpediente({
          idPersonal: this.savedIdPersonal,
          id: this.expedienteId,
          folio: this.expediente.folio,
        });
      }
      await this.fetchExpedientes();

      if (this.personalEdoFuerza) {
        this.personalEdoFuerza = {
          ...this.personal,
          idPersonal: Number(this.personal.cib),
          cib: String(this.savedIdPersonal),
        };
        await this.updatePersonalEdoFuerza(this.personalEdoFuerza);
      }

      this.closeDialog();
    },

    validaCurp(curp) {
      if (
        this.expedientes.some(
          (expediente) => expediente.Personal.curp.toLowerCase() === curp.toLowerCase(),
        )
      ) {
        return true;
      }
      return false;
    },

    async triggerSearchPersonal() {
      this.loading = true;
      const resultPersonalSearched = await this.searchPersonal(this.search);
      if (resultPersonalSearched.length > 0) {
        resultPersonalSearched[0].cib = resultPersonalSearched[0].idPersonal;
        delete resultPersonalSearched[0].idPersonal;
        this.personal = { ...resultPersonalSearched[0] };
        this.personalEdoFuerza = { ...resultPersonalSearched[0] };
      }
      this.search = '';
      this.loading = false;
    },
  },
};
</script>
